/*
 * @Author: your name
 * @Date: 2021-04-27 10:38:48
 * @LastEditTime: 2026-04-21 09:55:54
 * @LastEditors: zl21 602659667@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-business-components/js/OmsForm.js
 */
// import myInputLd from 'framework/components/element/input.vue' //为多选+导入组件专属引入
import myInputLd from 'r3cps/components/element/input.vue'
// 兼容fktable1.4数据格式（云雀1.0）
import myInput from "burgeonComponents/view/Fkinput.vue";
import fkinputPlus from "burgeonComponents/view/FkinputPlus.vue";
import BosPopInput from '@/component/bosPopInput/index.vue';
const utils = require("../common/js/utils").default;

export default {
  name: 'OmsForm',
  components: {
    fkinputPlus,
    myInput,
    myInputLd,
    BosPopInput,
  },
  data() {
    return {
      no: '',
      selectInputChangeVal: '',
      flodData: 'el-icon-arrow-down', //折叠箭头动态样式
      currentFlod: 'down', //存储当前选中的箭头状态
      url: {
        autoUrl: '/p/cs/fuzzyquerybyak',
        tableUrl: '/p/cs/QueryList',
        tableSearchUrl: '/p/cs/newQueryList'
      },
      network: R3.network,
      defaultGrid: { // 默认响应式栅格占位格数
        xs: 12,
        sm: 8,
        md: 8,
        lg: 6,
        span: 6
      },
      curGridColnum: 4,
      showNum: '', // 初始显示条数
      linkage: {
        arr: [], // 记录对应的联动字段
        assign: new Map(), // 记录联动字段关系映射 - 赋值
        clear: new Map() // 记录联动字段关系映射 - 清空
      }
    }
  },
  props: {
    /**
     * btn: 搜索按钮、格式同OmsButton
     * iconSite: 'rightTop', // 'bottomCenter' 折叠icon的位置
     * flodClick: 折叠回调
     * setColnum: 4, // 默认4列
     * setRow: 3, // 默认3行
     * isGrid: true, // 默认不启用栅格
     */
    formConfig: {
      type: Object
    }
  },
  computed: {
    // flodClickClass(){
    //   return this.formConfig.flodClick ? '' : 'unFlodStyle';
    // }
    ruleValidate() {
      return this.formConfig.ruleValidate || {}
    },
     formFields() {
      return this.formConfig.formData.filter(i => i.style)
    },
    // 查询条件默认显示行数
    queryDisNumber(v) {
      return $store.state.global.changeSearchFoldnum.queryDisNumber || 3
    },
    // 是否启用栅格（默认不启用）
    isGrid() {
      return this.formConfig.hasOwnProperty('isGrid') ? this.formConfig.isGrid : false
    },
    // 判断是否显示折叠按钮（判断查询条件是否 大于 查询条件默认显示行数*一行显示条数，大于才显示折叠按钮 ）
    searchInputLenMoreThanShowNum() {
      const hasMore = this.formConfig.formData.length > this.showNum
      console.log('hasMorehasMore::', hasMore);

      return hasMore
    },
    // 是否开启全局外键关联组件用arkDropMultiSelectFilter渲染
    isSwitchADMSF() {
      return window.ProjectConfig.globalDropFilterMode
    }
  },
  watch: {
     // 根据 查询条件默认显示行数 显示多少行
    queryDisNumber(v) {
      this.initRenderForm();
    },
    curGridColnum() {
      this.initRenderForm()
    },
    // flodData() {
    //   if (this.flodData === 'el-icon-arrow-up') {
    //     this.$refs[this.currentFlod].style.maxHeight = "";
    //   } else {
    //     // this.$refs[this.currentFlod].style.maxHeight = "96px";
    //     this.$refs[this.currentFlod].style.overflow = "hidden";
    //   }
    // }
    "formConfig.formValue": {
      handler(n) {
        if (this._formDataNormalizing) return;
        const f = this.formConfig.formData
        for (const key in n) {
          f.forEach(it => {
            if (it.colname == key && it.val !== n[key]) {
              it.val = n[key] // 给formData的item添加一个val记录此item的值，便于校验提示等
            }
          })
        }
      },
      immediate: true, // 初始化即执行
      deep: true,
    },
    "formConfig.formData": {
      handler(n) {
        if (!n || !n.length || this._formDataNormalizing) return;
        this._formDataNormalizing = true;
        try {
          let nextRules = null;
          let rulesChanged = false;

          n.forEach((i) => {
            const colname = this.getColname(i);
            if (i.colname !== colname) {
              i.colname = colname;
            }
            if (typeof i.rules === 'boolean') {
              i.rules = {};
            }

            // 设置表单验证规则-必填：兼容drp、mrp类型组件(popInput、popInputPlus、dropSelect)
            if (i.itemdata && Object.keys(i.itemdata).length) {
              if (!nextRules) {
                nextRules = { ...(this.formConfig.ruleValidate || {}) };
              }
              const isNotNull = !!i.itemdata.isnotnull;

              // 根修：非必填字段不应挂“required:false + 空message”的占位规则，否则会进入校验链导致误报
              if (!isNotNull) {
                if (Object.prototype.hasOwnProperty.call(nextRules, i.colname)) {
                  delete nextRules[i.colname];
                  rulesChanged = true;
                }
              } else {
                const existing = nextRules[i.colname];
                const conds = existing || [{ required: true, message: ' ', trigger: 'blur' }];
                if (Array.isArray(conds)) {
                  const index = conds.findIndex(r => r && Object.prototype.hasOwnProperty.call(r, 'required'));
                  if (index >= 0 && conds[index].required !== true) {
                    nextRules[i.colname] = conds.map((rule, idx) => (
                      idx === index ? { ...rule, required: true } : rule
                    ));
                    rulesChanged = true;
                  } else if (!existing) {
                    nextRules[i.colname] = conds;
                    rulesChanged = true;
                  }
                } else if (!existing) {
                  nextRules[i.colname] = conds;
                  rulesChanged = true;
                }
              }
            }
            // this.toggleValidClass(i)
          });

          if (rulesChanged && nextRules) {
            this.formConfig.ruleValidate = nextRules;
          }
          this.initRenderForm();
          this.linkageFields();
        } finally {
          this._formDataNormalizing = false;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  created() {
  },
  updated() {
    console.log('updated');
  },
  mounted() {
    // if (this.formConfig.flodClick) {
    //   // this.$refs[this.formConfig.flodClick].style.maxHeight = "96px";
    //   this.$refs[this.formConfig.flodClick].style.overflow = "hidden";
    // }
    const _this = this;
    window.addEventListener('keydown', e => {
      if (e.keyCode == 13) {
        if (_this.formConfig.btn && _this.formConfig.btn.buttons.length) {
          _this.formConfig.btn.buttons.find(it => it.webname == 'search').btnclick()
        }
      }
    });
    // this.asteriskColor()
    // 响应式栅格
    window.addEventListener('resize', () => this.getGridColnum(), false)
    this.getGridColnum()

    this.$nextTick(() => {
      // 拦截框架接口入参（由于刷新页面会出现过滤条件被重置问题，故特此处理）
      if (this.$refs.dropSelect && this.linkage.arr.length) {
        this.$refs.dropSelect.forEach(el => {
          el.$children[0].postTableData = function postTableData(url, message) {
            // 此处this指向下拉组件arkDropMultiSelectFilter
            return new Promise((resolve) => {
              this.post(url, utils.urlSearchParams({
                searchdata: this.searchdata
              }), (response) => {
                resolve(response);
              });
            });
          }
        })
      }
    })
  },
  destroyed() {
    window.removeEventListener('keydown', this, false);
    window.removeEventListener('resize', () => this.getGridColnum(), false)
  },
  methods: {
    getColname(item) {
      const { value, colname, itemdata, dataAcessKey } = item
      let result = colname ? colname : value ? value : dataAcessKey ? dataAcessKey : ''
      if (!result && itemdata && itemdata.colname) {
        result = itemdata.colname
      }
      return result
    },
    // 必填警告红框样式处理
    toggleValidClass(item) {
      let fk = item.itemdata && ['popInput', 'popInputPlus', 'dropSelect'].includes(item.style)
      let ref = item.style == 'dropSelect' || this.isSwitchADMSF ? 'dropSelect' : 'popLabel'
      let colname = this.getColname(item)
      if (!this.$refs[ref]) return
      let el = this.$refs[ref].find(i => i.$options.propsData.prop == colname)
      if (fk && el) {
        if ((el.isRequired && (item.itemdata.pid || item.itemdata.valuedata)) || !el.isRequired) {
          $(`.popInput.${colname}`).removeClass('ark-form-item-error')
        } else {
          $(`.popInput.${colname}`).addClass('ark-form-item-error')
        }
      }
    },
    // 必填星号(*)颜色
    asteriskColor(ms = 500) {
      setTimeout(() => {
        let nodes = this.$refs.popLabel;
        let nodes2 = this.$refs.dropSelect;
        let allNodes = [nodes, nodes2].filter(i => Array.isArray(i)).flat()
        allNodes.forEach(e => {
          let oldNodeStr = e.$el.firstElementChild.innerHTML;
          if (oldNodeStr.includes('*')) e.$el.firstElementChild.innerHTML = `<i style="color:#ed4014;">*</i> ${oldNodeStr.slice(1)}`;
        });
      }, ms);
    },
    /**
     * 常规栅格：即表单中都是span: 6
     * 特殊栅格：即表单中不都是span: 6
     */
    gridSize(item) {
      let oldSpan = Number(item.width)
      let mainSpan = this.getMost(this.formConfig.formData.map(i => i.width)).max
      let gridSize = {}
      if (this.isGrid) { // 开启响应式栅格
        Object.keys(this.defaultGrid).forEach(key => {
          switch (key) {
            case 'span':
              gridSize[key] = item.width || this.formConfig.colSpan || this.defaultGrid[key]
              break;
            case 'xs':
            case 'sm':
            case 'md':
            case 'lg':
              switch (oldSpan) {
                case 3:
                  gridSize[key] = ['lg', 'md'].includes(key) ? oldSpan : this.defaultGrid[key]
                  break;
                case 8:
                  gridSize[key] = mainSpan == 8 && key == 'lg' ? oldSpan : this.defaultGrid[key]
                  break;
                case 12:
                case 16:
                  gridSize[key] = ['sm', 'md'].includes(key) ? 16 : key == 'lg' ? oldSpan : 24
                  break;
                case 24:
                  gridSize[key] = oldSpan
                  break;
                default:
                  gridSize[key] = this.defaultGrid[key]
                  break;
              }
              break;
            default:
              break;
          }
        })
      } else {
        gridSize.span = item.width || this.formConfig.colSpan || this.defaultGrid.span
      }
      // console.log(item.width, item.label, gridSize)
      return gridSize
    },
    getMost(arr) {
      let max = null; // 出现次数最多的元素
      let num = 1; // 该元素出现次数
      arr.reduce((p, k)=>{
        p[k]? p[k]++ : p[k]=1;
        if(p[k] > num){
            num = p[k]
            max = k
        }
        return p
      },{})
      return { max, num }
    },
    // 当前栅格列数
    getGridColnum() {
      if (!this.formConfig.isGrid) return
      let clientWidth = document.body.clientWidth
      if (clientWidth >= 1200) {
        this.curGridColnum = 24 / this.defaultGrid.lg
        return
      }
      if (clientWidth >= 992) {
        this.curGridColnum = 24 / this.defaultGrid.md
        return
      }
      if (clientWidth >= 768) {
        this.curGridColnum = 24 / this.defaultGrid.sm
        return
      }
      if (clientWidth < 768) {
        this.curGridColnum = 24 / this.defaultGrid.xs
      }
    },
    initRenderForm() {
      if (!this.formConfig.flodClick) {
        return
      }
      setTimeout(() => {
        OMS.cssHandleUtils.refreshAgTableHeight() // 渲染定制列表页面ag表格
      }, 100)

      const { setColnum = this.curGridColnum, setRow = this.queryDisNumber } = this.formConfig
      console.log('setRowsetRow::', setRow, setColnum);

      let showNum;

      if (this.formConfig.btn) { // 场景：表单中含搜索按钮（预留按钮占位）
        showNum = setColnum * setRow - 1
      } else {
        showNum = setColnum * setRow
      }
      this.showNum = showNum
      /* if ( setColnum * setRow > this.formConfig.formData.length ) {
        // 不需要折叠icon的情况
        this.no = 'noFlod'
      } else {
        this.no = ''
      } */
      if (this.currentFlod == 'down') {
        this.formFields.forEach((it, n) => {
          const nextClass = n + 1 > showNum
            ? (it.class && /\blong\b/.test(it.class) ? it.class : (it.class ? `${it.class} long`.trim() : 'long'))
            : (it.class ? it.class.replace(/\blong\b/g, '').replace(/\s+/g, ' ').trim() : '');
          if (it.class !== nextClass) {
            it.class = nextClass;
          }
        });
      } else {
        this.formConfig.formData.forEach((it) => {
          const nextClass = it.class ? it.class.replace(/\blong\b/g, '').replace(/\s+/g, ' ').trim() : '';
          if (it.class !== nextClass) {
            it.class = nextClass;
          }
        });
      }
      this.$forceUpdate()
    },
    selectInputChange(x) {
      this.selectInputChangeVal = x;
    },
    selectEnter(item, val, e) {
      if (e.keyCode == 13) {
        if (typeof item.selectEnter == 'function') {
          this.runMethods(item.selectEnter(this.selectInputChangeVal || val), true);
        } else {
          console.error('未定义selectEnter方法!')
        }
        // this.$emit('selectEnter', this.selectInputChangeVal);
      }
    },
    runMethods(val, flag) {
      if (val) {
        flag ? val(e) : val();
      }
    },
    validate(callback) {
      this.$refs['businessForm_a'].validate(callback)
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },

    oneObj(val) {
      if (val) {
        val(e);
      }
    },

    //点击折叠按钮事件
    flodClick(val) {
      // if (this.flodData === 'el-icon-arrow-up') {
      //   this.flodData = 'el-icon-arrow-down';
      //   // this.currentFlod = val;

      // } else {
      //   this.flodData = 'el-icon-arrow-up';
      //   // this.currentFlod = val;
      // }
      this.flodData = this.flodData === 'el-icon-arrow-down' ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
      this.currentFlod = this.flodData == 'el-icon-arrow-down' ? 'down' : 'up'
      if (typeof val == 'function') {
        val(this.currentFlod);
      }
      this.initRenderForm()
    },
    // 接口入参- 模糊传参
    sendAutoMessage(item) {
      return { colid: item.itemdata.colid }
    },
    // 接口入参- 表格模糊传参
    sendTableMessage(item) {
      const { isdroplistsearch, colid, colname, refcolval } = item.itemdata
      // 定制查询接口
      if (typeof item.popBefore == 'function') {
        this.url.tableSearchUrl = item.itemdata.api
        this.runMethods(item.popBefore(item.itemdata))
        return item.itemdata.params
      }
      this.url.tableSearchUrl = '/p/cs/newQueryList'

      let params = {
        isdroplistsearch: isdroplistsearch || true,
        refcolid: colid,
      }
      // 联动-过滤条件
      if (refcolval && colname) {
        const mapKeys = [...this.linkage.assign.keys()]
        const needLinkage = mapKeys.includes(colname)
        if (needLinkage) {
          const isMultiLevelLinkage = colname != this.linkage.assign.get(colname) // 多级联动
          const isSingleLevelLinkage = colname == this.linkage.assign.get(colname) && item.inputList // 一级联动
          if (isMultiLevelLinkage || isSingleLevelLinkage) {
            const { fixcolumn, expre } = refcolval // 过滤配置
            const arithmetic = expre == 'equal' ? '=' : '' // 运算符
            // 1、多级联动-过滤条件（无inputList)，比如省市区
            if (isMultiLevelLinkage) {
              const fieldObj = utils.queryForm(this.formConfig, this.linkage.assign.get(colname)) // 查找上一级字段
              if (fieldObj && fieldObj.itemdata && fieldObj.itemdata.pid) {
                // 过滤条件值不能为空，会导致弹窗报错提示（clear清空后，也会调一次接口）
                const pid = fieldObj.itemdata.pid
                params.fixedcolumns = { [fixcolumn]: `${arithmetic}${pid}` }
                delete item.itemdata.isShowPopTip
              }
            }
            // 2、一级联动-过滤条件（写死的inputList），比如指定平台的店铺
            if (isSingleLevelLinkage) {
              item.inputList.forEach(i => {
                if (i.childs) {
                  i.childs.forEach(i => {
                    if (i.colname == colname) {
                      if (params.fixedcolumns) {
                        params.fixedcolumns[fixcolumn] = `${arithmetic}${i.refobjid}`
                      } else {
                        params.fixedcolumns = { [fixcolumn]: `${arithmetic}${i.refobjid}` }
                      }
                    }
                  })
                }
              })
            }
          }
        }
      }
      // 3、一级联动-过滤条件 支持多条件过滤
      if (item.itemdata.filterConds && item.itemdata.filterConds.length) {
        item.itemdata.filterConds.forEach(i => {
          let val = i.expre == '=' ? `=${i.refobjid}` : `${i.refobjid}`
          if (params.fixedcolumns) {
            params.fixedcolumns[i.fixcolumn] = val
          } else {
            params.fixedcolumns = { [i.fixcolumn]: val }
          }
        })
      }
      // 4、配置了权限(主要是pos)
      if (item.itemdata.precolnameslist && item.itemdata.precolnameslist.length) {
        params.precolnameslist = item.itemdata.precolnameslist
      }
      return params
    },
    // 记录联动字段 - 便于更新联动字段的接口入参
    linkageFields() {
      /**
       * 联动字段相关（eg: A-B-C）
       * fields 记录对应联动字段 [['A', 'B', 'C'], ...]
       * assignMap 联动-赋值 Map(2) {'B' => 'A', 'C' => 'B', ...}
       * clearMap  联动-清空 Map(2) {'A' => 'B', 'B' => 'C', ...}
       */
      let fields = []
      let assignMap = new Map()
      let clearMap = new Map()
      let fkStyle = this.isSwitchADMSF ? ['dropSelect', 'popInput'] : ['dropSelect']
      this.formConfig.formData.forEach(item => {
        if (fkStyle.includes(item.style)) {
          if (item.itemdata && item.itemdata.refcolval) {
            const { srccol } = item.itemdata.refcolval
            assignMap.set(item.itemdata.colname, srccol)
            clearMap.set(srccol, item.itemdata.colname)
            if (!fields.length) {
              fields.push([srccol, item.itemdata.colname]) // * 取item.itemdata.colname 记录字段名，后续也根据它查找字段
            } else {
              let isAdd = false
              fields.forEach(i => {
                if (i.slice(-1)[0] == srccol) {
                  i.push(item.itemdata.colname)
                  isAdd = true
                }
              })
              !isAdd && fields.push([srccol, item.itemdata.colname])
            }
          }
        }
      })
      this.linkage = {
        arr: fields,
        assign: assignMap,
        clear: clearMap
      }
    },
    /**
     * dropSelect 属性集合
     * @param {*} item
     */
    propsData(item) {
      const { single, fkdisplay, pid, valuedata } = item.itemdata;
      let fkStyle = this.isSwitchADMSF ? ['dropSelect', 'popInput'] : ['dropSelect']
      const defaultSelectedDrp = fkStyle.includes(item.style)
        && fkdisplay == 'drp'
        && [{ ID: pid, Label: valuedata }]
      const isShowPopTip = typeof item.itemdata.isShowPopTip == 'function'
        ? item.itemdata.isShowPopTip
        : function () { return true }

      return {
        custom: true, // 绕过r3里被重写的组件方法'postTableData'
        single: fkdisplay == 'mrp' ? false : fkdisplay == 'drp' ? true : !!single, // 是否单选
        placeholder: item.itemdata.placeholder || $i18n.t('form.selectPlaceholder'),
        enterType: false,
        serviceId: item.itemdata.serviceId || '',
        // totalRowCount: item.itemdata.totalRowCount || 0,
        pageSize: Number(localStorage.getItem('fkRange') || 20),
        isBackRowItem: item.itemdata.isBackRowItem || false,
        dataEmptyMessage: item.itemdata.dataEmptyMessage || '数据加载中...',
        columns: item.itemdata.columns || [],
        columnsKey: item.itemdata.columnsKey || [],
        showColnameKey: item.itemdata.showColnameKey || 'isak',
        hidecolumns: item.itemdata.hidecolumns || [],
        defaultSelected: item.itemdata.defaultSelectedMrp || defaultSelectedDrp || [],
        className: item.itemdata.className || '',
        item: {}, // 这个属性为了解决DropMultiSelectFilter报错问题，无需传值
        isShowPopTip, // 点击icon的时候是否显示下拉框
      };
    },
    /**
     * dropSelect 当值改变时触发
     * @param {*} val
     * @param {*} item
     */
    valueChange(val, item) {
      let arg
      val = val || []
      const { fkdisplay, isBackRowItem } = item.itemdata
      if (fkdisplay == 'drp' && val.length) {
        item.itemdata.pid = val[0].ID;
        item.itemdata.valuedata = val[0].Label;
        item.itemdata.defaultSelectedMrp = val;
        arg = isBackRowItem ? val[0] : item.itemdata
      } else {
        item.itemdata.pid = '';
        item.itemdata.valuedata = '';
        val.forEach((it) => {
          item.itemdata.pid += `${it.ID},`;
          item.itemdata.valuedata += `${it.Label},`;
        })
        item.itemdata.pid = item.itemdata.pid.replace(/,$/, '');
        item.itemdata.valuedata = item.itemdata.valuedata.replace(/,$/, '');
        item.itemdata.defaultSelectedMrp = val;
        arg = isBackRowItem ? val : item.itemdata
      }
      if (typeof item.oneObj == 'function') {
        this.runMethods(item.oneObj(arg))
        // 联动-清空赋值
        if (fkdisplay == 'drp' && this.linkage.arr.length) {
          this.linkageClear(item)
        }
      }
    },
    // 多级联动-清空赋值
    linkageClear(item) {
      const { colname } = item.itemdata
      if (colname) {
        const mapKeys = [...this.linkage.clear.keys()]
        const needLinkage = mapKeys.includes(colname)
        if (needLinkage && mapKeys != colname) {
          const field = this.linkage.clear.get(colname)
          const fieldObj = utils.queryForm(this.formConfig, field) // 查找下一级字段
          if (fieldObj && fieldObj.itemdata) {
            fieldObj.itemdata.pid = ''
            fieldObj.itemdata.valuedata = ''
            fieldObj.itemdata.dropValue = []
            fieldObj.itemdata.defaultSelectedMrp = []
            fieldObj.itemdata.isShowPopTip = () => {
              if (item.itemdata.pid && item.itemdata.valuedata) {
                return true
              }
              this.$Message.error(`请先选择${item.itemdata.name}！`)
              return false
            }
          }
          if (mapKeys.includes(field)) this.linkageClear(fieldObj)
        }
      }
    },
    blur(val, itemdata) {
      // 失焦：模糊搜索的选中、clear都会先走失焦
      // if (this.isFuzzy && !this.isHandleSelect) {
      //   console.warn('fuzzy blur，模糊搜索失去焦点了，自行处理！');
      //   setTimeout(() => {
      //     if (this.itemdata.pid && this.itemdata.valuedata) { // 假装已经走了选中事件
      //       return
      //     } else {
      //       if (this.AutoData.length) {
      //         const val = this.AutoData;
              itemdata.pid = val.map(i => i.ID).join();
              itemdata.valuedata = val.map(i => i.Label).join();
      //         if (this.isBackRowItem) {
      //           this.$emit('inputBlur', val[0]);
      //         } else {
                this.$emit('inputBlur', itemdata);
      //         }
      //       } else {
      //         console.warn('模糊搜索未查询到数据！');
      //         this.itemdata.pid = '';
      //         this.itemdata.valuedata = '';
      //         if (this.isBackRowItem) {
      //           this.$emit('inputBlur', {});
      //         } else {
      //           this.$emit('inputBlur', this.itemdata);
      //         }
      //       }
      //     }
      //     this.isHandleSelect = false;
      //   }, 3000);
      // } else {
      //   console.warn('not fuzzy blur');
      // }
    },
    clear(val, itemdata) {
      console.log(itemdata);
      itemdata.pid = '';
      itemdata.valuedata = '';
      this.$emit('inputClear', itemdata);
      // if (this.isBackRowItem) {
      //   this.$emit('getFkChooseItem', {});
      // } else {
      //   this.$emit('getFkChooseItem', this.itemdata);
      // }
    },
  }
}
